<template>
  <div id="cms-page">
    <breadcrumbs
      :with-homepage="true"
      :routes="[]"
      :active-route="cmsPageContent.title"
    />
    <div class="container">
      <h1 class="page-title" v-if="cmsPageContent.content_heading">
        {{ cmsPageContent.content_heading }}
      </h1>
    </div>

    <div class="faq">
      <div
        class="container"
        :id="cmsPageContent.content.includes('pagebuilder') ? 'html-body' : ''"
        :class="cmsPageContent.content.includes('pagebuilder') ? 'pagebuilder-container' : ''"
        v-html="cmsPageContent.content"
        ref="cmscontent"
      />
    </div>
  </div>
</template>

<script>
import Breadcrumbs from 'theme/components/core/Breadcrumbs'
import CmsPage from '@vue-storefront/core/pages/CmsPage'

export default {
  components: {
    Breadcrumbs
  },
  computed: {
    cmsPageContent () {
      return this.$store.state.cmsPage.current
    }
  },
  mounted () {
    const panelHeadings = this.$refs.cmscontent.getElementsByClassName('panel-heading');
    for (let i = 0; i < panelHeadings.length; i++) {
      panelHeadings[i].addEventListener('click', function (event) {
        event.preventDefault();
        this.parentElement.classList.toggle('show');
      })
    }
  },
  mixins: [CmsPage]
}
</script>
